import React, { useEffect, useState, useMemo, useRef } from 'react'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import {
  getScaleTickets,
  getContractWithComId,
  getCommittedUnitsForContract,
  searchCompaniesByType
} from '../../services/apiHelper'
import Button from 'syngenta-react-components/dist/components/Button'
import TypeAhead from '../../dpe-usco/components/TypeAhead/TypeAhead'
import Select from '../../dpe-usco/components/Select/Select'
import close from '../../assets/icons/close.svg'
import { Modal } from 'syngenta-react-components'
import { useTable } from 'react-table'
import moment from 'moment'
import _ from 'lodash'
import { generatePDF, generateExcel } from './GenerateDocument'
import CloseButton from '../../components/subComponents/CloseButton'
import './TabButtonStyles.css'

const generateMonthMap = (year, deliveryType) => {
  const startDate = year ? `${year}-09-01` : new Date().getFullYear() + '-09-01'
  const momentDate = moment(startDate)

  const monthMap = new Map()
  for (const i of Array.from({ length: 13 }).keys()) {
    const newDate = momentDate.clone().add(i, 'month')
    const delivery_month = newDate.format('MMM-YY')
    const month = newDate.format('MMMM').toLowerCase()
    const year = newDate.format('YYYY')
    monthMap.set(delivery_month, {
      delivery_month,
      month,
      year,
      delivery_type: deliveryType,
      harvest_bushels: 0
    })
  }
  return monthMap
}

const emptyDataRow = (companyName, year) => {
  const currYear = year.toString().slice(2)
  const nextYear = (+year + 1).toString().slice(2)
  return {
    company: companyName,
    growerName: '-',
    [`Sep-${currYear}`]: '-',
    [`Oct-${currYear}`]: '-',
    [`Nov-${currYear}`]: '-',
    [`Dec-${currYear}`]: '-',
    [`Jan-${nextYear}`]: '-',
    [`Feb-${nextYear}`]: '-',
    [`Mar-${nextYear}`]: '-',
    [`Apr-${nextYear}`]: '-',
    [`May-${nextYear}`]: '-',
    [`Jun-${nextYear}`]: '-',
    [`Jul-${nextYear}`]: '-',
    [`Aug-${nextYear}`]: '-',
    [`Sep-${nextYear}`]: '-',
    total: 0
  }
}

export const filterCommittedUnitForGrower = (
  response,
  grower_name,
  contract_id
) => {
  let committedUnits = []
  const data = response.data.committed_units.filter(curr => {
    return (
      curr.display_details.grower_name.toLowerCase() ===
        grower_name.toLowerCase() && curr.external_reference_id === contract_id
    )
  })

  data.forEach(obj => {
    let total_contract_units = 0
    let total_harvest_bushels = 0
    obj.committed_units.forEach(obj1 => {
      total_contract_units += obj1.contract_units
      total_harvest_bushels += obj1.harvest_bushels
    })
    obj.committed_units.forEach(obj2 => {
      obj2.harvest_bushels = Math.round(
        (obj2.contract_units / total_contract_units) * total_harvest_bushels
      )
    })
    committedUnits = [...committedUnits, ...obj.committed_units]
  })
  response.data.child_plans.forEach(obj2 => {
    obj2.monthly_units.forEach(obj3 => {
      const objNew = {
        delivery_type: obj3.end_product_type,
        delivery_month: obj3.month,
        delivery_year: obj3.year,
        contract_acres: obj3.child_plan_acres,
        contract_units: obj3.child_plan_units,
        harvest_bushels: 0
      }
      committedUnits = [...committedUnits, objNew]
    })
  })
  return committedUnits
}


const NetBushelsReport = () => {
  const [reportYear, setReportYear] = useState(
    new Date().getFullYear().toString()
  )
  const [filteredCompanyDropDown, setFilteredCompanyDropDown] = useState()
  const [filteredGrowerDropDown, setFilteredGrowerDropDown] = useState()
  const [filteredContractIdDropDown, setFilteredContractIdDropDown] = useState()
  const [companyLoadingState, setCompanyLoadingState] = useState(false)
  const [searchGrowerName, setSearchGrowerName] = useState('')
  const [searchContractID, setSearchContractID] = useState('')
  const [company, setCompany] = useState()
  const [searchCompany, setSearchCompany] = useState('')
  const [reportStatus, setReportStatus] = useState('')
  const [reportPdfUrl, setReportPdfUrl] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [report, setReport] = useState([])
  const grainReceiverDebounce = useRef()
  const canceled = useRef(false)
  const [stopSearch, setStopSearch] = useState(false)
  const [deliveryType, setDeliveryType] = useState({ type: 'grain', index: 1 })
  const [allContractData, setAllContractData] = useState()
  const [yearsOptions] = useState([2022, 2023, 2024, 2025, 2026])
  const [grower, setGrower] = useState({})
  const [isContractCommFeed, setContractCommFeed] = useState(false)
  const [stopSearchID, setStopSearchID] = useState(false)
  const [allContractDataYears, setAllContractDataYears] = useState([])
  const [scaleTicketsObj, setScaleTicketsObj] = useState({})

  // Function to fetch data based on company_id and limit
  const fetchData = async (company_id, limit) => {
    setReportStatus('LOADING')
    const isLoadedData = allContractDataYears.filter(
      year => year.toString() === reportYear.toString()
    )
    if (isLoadedData.length > 0) {
      setReportStatus()
      setAllContractData({ ...allContractData })
      return
    }
    const obj = { ...allContractData }
    allContractDataYears.push(reportYear.toString())

    try {
      let arr = await getContractWithComId(company_id, limit)
      arr = arr.data?.contracts
      const statusArr = [
        'pending',
        'pendinggrowersigned',
        'amendment_pending',
        'amendmentpendinggrowersigned',
        'completed',
        'amendment_completed'
      ]
      if (arr && arr.length) {
        const filteredArr = arr.filter(el => {
          return statusArr.some(f => {
            return (
              f === el.contract_state &&
              el.new_contract_id.slice(0, 2).toString() ===
                allContractDataYears[allContractDataYears.length - 1]
                  .slice(2)
                  .toString()
            )
          })
        })
        arr = [...filteredArr]
      }
      let contractType = false
      if (arr.length > 0 && !canceled.current) {
        const contracts = arr
        const production_plan_id = contracts[0].contract_production_plan_id
        const response = await getCommittedUnitsForContract(production_plan_id)
        contracts.map(async contract => {
          const grower_name = contract.grower_name

          const contract_id = contract.contract_id

          if (
            contract.contract_details.display_details.contract_type ===
            'commercial-feed'
          ) {
            contractType = true
          }
          const data = filterCommittedUnitForGrower(
            response,
            grower_name,
            contract_id
          )
          if (!obj[grower_name]) {
            obj[grower_name] = {
              contracts: {
                data: [
                  {
                    data: [...data],
                    new_contract_id: contract.new_contract_id,
                    contract_id: contract_id,
                    production_plan_id: production_plan_id,
                    contract_start_execution: contract.contract_start_execution
                  }
                ]
              }
            }
          } else {
            obj[grower_name]['contracts'].data.push({
              data: [...data],
              new_contract_id: contract.new_contract_id,
              contract_id: contract_id,
              production_plan_id: production_plan_id,
              contract_start_execution: contract.contract_start_execution
            })
          }
        })
      }

      setAllContractData(obj)
      setDeliveryType({ type: 'grain', index: 1 })
      contractType ? setContractCommFeed(true) : setContractCommFeed(false)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    // get companies report data for calculating Received Bushels
    if (company && company.company_id) {
      fetchData(company.company_id, 1000)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, reportYear])

  const getTotalReceived = async contractData => {
    const { production_plan_id } = contractData

    if (scaleTicketsObj && scaleTicketsObj[production_plan_id]) {
      return scaleTicketsObj[production_plan_id]
    }

    try {
      const response = await getScaleTickets(production_plan_id, null)
      const updatedScaleTicketsObj = {
        ...scaleTicketsObj,
        [production_plan_id]: response
      }
      setScaleTicketsObj(updatedScaleTicketsObj)
      return response
    } catch (error) {
      console.error('Error fetching scale tickets:', error)
      return null
    }
  }

  const getFilteredTotalReceived = (scaleTickets, contract_id, grower_name) => {
    scaleTickets =
      scaleTickets.length > 0 &&
      scaleTickets.filter(currScaleTicket => {
        return (
          currScaleTicket.grower_name.toLowerCase() ===
            grower_name.toLowerCase() &&
          currScaleTicket.original_new_contract_id.toLowerCase() ===
            contract_id.toLowerCase()
        )
      })

    let totalNetQty = 0
    if (scaleTickets.length) {
      scaleTickets.forEach(ticket => {
        let selectedNetQty = 0
        if (ticket.net_quantity && typeof ticket.net_quantity === 'string') {
          selectedNetQty = parseFloat(ticket.net_quantity.replace(/,/g, ''))
        }
        if (ticket.net_quantity && typeof ticket.net_quantity === 'number') {
          selectedNetQty = ticket.net_quantity
        }
        totalNetQty = totalNetQty + selectedNetQty
      })
    }
    return totalNetQty
  }

  const displaySingleRow = async (
    reportYear,
    committedUnitsData,
    grower_name
  ) => {
    setReport([])
    const deliveryTypes =
      committedUnitsData?.data.length > 0
        ? [
          ...new Set(
            committedUnitsData.data.map(curr => curr.delivery_type)
          )
        ]
        : []
    const formatUnits = () => {
      const workingObj = {}
      deliveryTypes.forEach(deliveryType => {
        const filteredCommittedUnits = committedUnitsData.data.filter(
          comUnit => {
            return (
              comUnit.delivery_type === deliveryType &&
              (comUnit.delivery_year.toString() ===
                parseInt(reportYear).toString() ||
                comUnit.delivery_year.toString() ===
                  (parseInt(reportYear) + 1).toString())
            )
          }
        )
        let committedUnitsMap = null
        committedUnitsMap = generateMonthMap(reportYear, deliveryType)
        if (filteredCommittedUnits.length) {
          filteredCommittedUnits.forEach(comUnit => {
            const delivery_month = moment(
              `${comUnit.delivery_month}, 1 ${comUnit.delivery_year}`
            ).format('MMM-YY')
            const current = committedUnitsMap.get(delivery_month)
            if (current) {
              const totalHarvestBushels =
                parseInt(current.harvest_bushels) +
                parseInt(comUnit.harvest_bushels)
              const returnable = {
                ...current,
                harvest_bushels: totalHarvestBushels
              }
              committedUnitsMap.set(delivery_month, returnable)
            } else {
              committedUnitsMap.set(delivery_month, comUnit)
            }
          })
        }
        workingObj[deliveryType] = committedUnitsMap
      })
      const returnObj = {}
      deliveryTypes.forEach(deliveryType => {
        let typeArray = []
        const currentMap = workingObj[deliveryType]
        currentMap.forEach(comUnit => {
          typeArray.push(comUnit)
        })
        returnObj[deliveryType] = typeArray
      })
      return returnObj
    }
    const returnable = formatUnits()
    returnable.contract_year = reportYear
    if (returnable) {
      let netTotalReceived = 0
      const { contractData } = committedUnitsData
      let scaletickestForYear = []
      if (contractData.length > 0) {
        scaletickestForYear = await getTotalReceived(contractData[0])
      }
      // collecting all the totalReceived value for all the production plan in  contracts
      for (let j = 0; j < contractData.length; j++) {
        const totalNetQty = getFilteredTotalReceived(
          scaletickestForYear,
          contractData[j].contract_id,
          grower_name
        )
        netTotalReceived += totalNetQty
      }
      return {
        monthlyUnits: returnable,
        totalReceived: netTotalReceived
      }
    } else {
      setReportStatus('EMPTY')
    }
  }

  const generateTabs = async monthlyUnits => {
    const tabGenerator = async (type, monthlyUnits) => {
      let data = monthlyUnits ? monthlyUnits[type] : []
      let responseObj = {}
      if (monthlyUnits && monthlyUnits.contract_year) {
        delete monthlyUnits.contract_year
      }
      for (let type in monthlyUnits) {
        let sumReceivedUnits = 0
        let sumHarvestBushels = 0
        monthlyUnits[type].forEach(unit => {
          if (unit.harvest_bushels) {
            sumHarvestBushels += Math.round(
              parseFloat(unit.harvest_bushels) || 0
            )
          }
        })
        responseObj[type] = {
          sumHarvestBushels,
          sumReceivedUnits
        }
      }
      const adjustedData = data.map(month => {
        if (month.harvest_bushels < month.net_quantity) {
          const newMonth = { ...month }
          newMonth.net_quantity = month.harvest_bushels
          return newMonth
        } else return month
      })
      data = adjustedData
      return data
    }
    return await tabGenerator(deliveryType.type, monthlyUnits)
  }

  const handleSearchCompany = e => {
    e.preventDefault()
    if (e.target.value === '') {
      setCompanyLoadingState(false)
      setStopSearch(false)
      setCompany()
      setAllContractData()
      setReport([])
      setAllContractDataYears([])
      setScaleTicketsObj({})
    }
    setSearchCompany(e.target.value)
    setStopSearch(false)
  }

  const _grainReceiverCallback = item => {
    setCompany(item)
    setAllContractData()
    setReport([])
    setAllContractDataYears([])
    setScaleTicketsObj({})
    setSearchCompany(item.company_name)
    setStopSearch(true)
  }

  const _growerCallback = item => {
    setGrower(item)
    setReport([])
    setSearchGrowerName(item.grower_name)
    setFilteredGrowerDropDown()
  }
  const _contractIdCallback = item => {
    setSearchContractID(item.contract_id)
    setFilteredContractIdDropDown()
    setStopSearchID(true)
    setReport([])
  }

  const handleSearchGrower = e => {
    e.preventDefault()
    setSearchGrowerName(e.target.value)
    setGrower({})
  }

  const handleSearchContractId = e => {
    e.preventDefault()
    setSearchContractID(e.target.value)
    setStopSearchID(false)
  }

  const handleClose = () => {
    setShowModal(false)
  }

  // Function to handle tab selection for better accessibility
  const handleTabSelection = (type, index) => {
    setDeliveryType({ type, index })
  }

  useEffect(() => {
    return () => {
      canceled.current = true
    }
  }, [])

  useEffect(() => {
    // search company by there types
    const searchForCompany = () => {
      searchCompaniesByType(searchCompany, [
        'grain-receiver',
        '3PO',
        'syngenta'
      ])?.then(res => {
        if (!canceled.current) {
          setFilteredCompanyDropDown(res)
          setCompanyLoadingState(false)
        }
      })
    }
    if (searchCompany.length >= 3 && !stopSearch) {
      clearTimeout(grainReceiverDebounce.current)
      setCompanyLoadingState(true)
      grainReceiverDebounce.current = setTimeout(searchForCompany, 300)
    }
  }, [searchCompany, stopSearch])

  // creating table headers based on the report Year
  const generateMonthHeaders = year => {
    const currYear = year.toString().slice(2)
    const nextYear = (year + 1).toString().slice(2)
    const months = [
      'Sep',
      'Oct',
      'Nov',
      'Dec',
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep'
    ]
    return months.map((month, index) => {
      const isNextYear = index >= 4
      return {
        Header: `${month}-${isNextYear ? nextYear : currYear}`,
        accessor: `${month}-${isNextYear ? nextYear : currYear}`
      }
    })
  }

  const columns = useMemo(() => {
    const year = +reportYear
    return [
      {
        Header: 'Company',
        accessor: 'company',
        aggregate: 'count',
        Aggregated: ({ value }) => `${value} Growers`
      },
      {
        Header: 'Grower Name',
        accessor: 'growerName'
      },
      ...generateMonthHeaders(year),
      {
        Header: 'Net Total',
        accessor: 'total'
      }
    ]
  }, [reportYear])

  // create single row data for contract
  const createRow = async (grower_name, growerDetails) => {
    let { monthlyUnits, totalReceived } = await displaySingleRow(
      reportYear,
      growerDetails,
      grower_name
    )
    const harvestData = await generateTabs(monthlyUnits)
    // creating single row for each grower
    const newRow = {
      company: company.company_name,
      growerName: grower_name
    }
    let total = totalReceived
    harvestData.forEach(curr => {
      let currBushels = curr.harvest_bushels || 0
      let finalValue = Math.min(currBushels, total)
      newRow[curr.delivery_month] = finalValue <= 0 ? '-' : finalValue
      total = total - currBushels
    })
    newRow['total'] = totalReceived || 0
    return newRow
  }

  const capitalizeLetters = str => {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  useEffect(() => {
    const processContracts = async () => {
      try {
        if (!company || !company.company_name) {
          setReport([])
          setReportStatus('EMPTY')
          return
        }
        setReportStatus('LOADING')
        let rows = []
        const processData = async (contracts, growerName, isContractId) => {
          let filteredData = []
          let contractData = []
          let reportDataForyear = []
          if (isContractId) {
            if (
              contracts.contract_start_execution.slice(0, 4) ===
              reportYear.toString()
            ) {
              for (let i = 0; i < contracts.data.length; i++) {
                filteredData.push(contracts.data[i])
                reportDataForyear.push(contracts.data[i])
              }
              contractData.push({
                production_plan_id: contracts.production_plan_id,
                contract_id: contracts.new_contract_id
              })
            }
          } else {
            for (let i = 0; i < contracts.data.length; i++) {
              if (
                contracts.data[i].contract_start_execution.slice(0, 4) ===
                reportYear.toString()
              ) {
                if (contracts.data[i].data.length > 0) {
                  filteredData.push(contracts.data[i].data)
                  reportDataForyear.push(contracts.data[i].data)
                  if (
                    contracts.data[i].data[0].delivery_type ===
                    deliveryType.type
                  ) {
                    contractData.push({
                      production_plan_id: contracts.data[i].production_plan_id,
                      contract_id: contracts.data[i].new_contract_id
                    })
                  }
                }
              }
            }
          }

          filteredData = _.flatten(filteredData)
          reportDataForyear = _.flatten(reportDataForyear)

          filteredData = filteredData.filter(curr => {
            return curr.delivery_type === deliveryType.type
          })
          const filteredContract = {
            data: filteredData,
            contractData: contractData
          }

          if (filteredData.length > 0) {
            const row = await createRow(growerName, filteredContract)
            rows.push(row)
          } else if (
            filteredData.length === 0 &&
            reportDataForyear.length > 0
          ) {
            const row = emptyDataRow(company.company_name, reportYear)
            rows.push(row)
          }
        }

        if (searchContractID.length > 0) {
          if (grower.grower_name) {
            for (let j = 0; j < grower.data.contracts.data.length; j++) {
              if (
                grower.data.contracts.data[j].new_contract_id ===
                searchContractID
              ) {
                await processData(
                  grower.data.contracts.data[j],
                  grower.grower_name,
                  true
                )
              }
            }
          } else {
            for (const grower in allContractData) {
              for (const contract of allContractData[grower].contracts.data) {
                if (
                  contract.new_contract_id ===
                  searchContractID
                ) {
                  await processData(
                    contract,
                    grower,
                    true
                  )
                }
              }
            }
          }
          setFilteredContractIdDropDown()
        } else if (grower.grower_name) {
          const { contracts } = grower.data
          await processData(contracts, grower.grower_name)
        } else if (
          searchContractID.length === 0 &&
          searchGrowerName.length === 0
        ) {
          for (const contract in allContractData) {
            await processData(allContractData[contract].contracts, contract)
          }
        }
        if (rows.length > 0) {
          setReport(rows)
          setReportStatus(false)
        } else {
          setReport([])
          setReportStatus('EMPTY')
        }
      } catch (error) {
        console.error('Error processing contracts:', error)
        setReportStatus('ERROR')
      }
    }

    if (company?.company_name !== undefined) {
      setReportStatus('LOADING')
      processContracts()
    } else {
      setReportStatus('EMPTY')
    }

    // create Grower name  Drop down for selected year
    if (searchGrowerName.length > 0 && !grower.grower_name) {
      let filteredGrowers = []
      let uniqueNames = new Set()
      for (let grower in allContractData) {
        for (let i = 0; i < allContractData[grower].contracts.data.length; i++) {
          if (allContractData[grower].contracts.data[i].contract_start_execution.slice(0, 4) === reportYear.toString()) {
            if (!uniqueNames.has(grower)) {
              uniqueNames.add(grower)
              filteredGrowers.push({
                grower_name: capitalizeLetters(grower),
                data: allContractData[grower]
              })
            }
          }
        }
      }
      setFilteredGrowerDropDown(filteredGrowers)
    } else {
      setFilteredGrowerDropDown()
    }

    // filter out all contract id with in reported year
    const filterContractsByYear = (contractData, reportYear) => {
      const filteredContracts = []
      const uniqueContracts = new Set()

      for (let i = 0; i < contractData.length; i++) {
        if (
          contractData[i].contract_start_execution.slice(0, 4) ===
          reportYear.toString()
        ) {
          if (!uniqueContracts.has(contractData[i].new_contract_id)) {
            uniqueContracts.add(contractData[i].new_contract_id)
            filteredContracts.push({
              contract_id: contractData[i].new_contract_id
            })
          }
        }
      }
      return filteredContracts
    }

    const getFilteredContractIds = (grower, allContractData, reportYear) => {
      let filteredContractIds = []

      if (grower.grower_name) {
        filteredContractIds = filterContractsByYear(
          grower.data.contracts.data,
          reportYear
        )
      } else {
        for (let growerName in allContractData) {
          const contractsData = allContractData[growerName].contracts.data
          filteredContractIds = [
            ...filteredContractIds,
            ...filterContractsByYear(contractsData, reportYear)
          ]
        }
      }
      return filteredContractIds
    }

    // create contract ID Drop down for selected year
    if (searchContractID.length > 0 && !stopSearchID) {
      const filteredContractIds = getFilteredContractIds(
        grower,
        allContractData,
        reportYear
      )
      setFilteredContractIdDropDown(filteredContractIds)
    } else {
      setFilteredContractIdDropDown()
    }

    if (grower.grower_name) {
      setFilteredGrowerDropDown()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    allContractData,
    grower,
    searchGrowerName,
    searchContractID,
    deliveryType
  ])

  // logic for generating pdf report
  useEffect(() => {
    setReportPdfUrl('')
    generatePDF('#table-to-pdf', 'Net Bushels Report').then(res =>
      setReportPdfUrl(res)
    )
  }, [report])

  const callToDownloadExlSheet = () => {
    // define table structure
    const table = '.table'
    const header = '.tableHeader > div'
    const body = '.tableBody > div'
    generateExcel(table, header, body)
  }

  return (
    <>
      <div className="m25">
        <div className="report-container">
          <h4>Net Bushels Report</h4>
          <div className="search-box">
            <div className="search-lists">
              <div className="df mb10 jcsb">
                <div className="w100%">
                  <TypeAhead
                    className={'mb20'}
                    value={searchCompany}
                    onChange={handleSearchCompany}
                    item_id="company_id"
                    item_value="company_name"
                    data={filteredCompanyDropDown}
                    callback={_grainReceiverCallback}
                    loading={companyLoadingState}
                    placeholder="Company Name"
                  />
                </div>
              </div>

              <div className="df mb10 jcsb">
                <div className="w100%">
                  <TypeAhead
                    className={'mb20'}
                    value={searchGrowerName}
                    onChange={handleSearchGrower}
                    item_id="grower_name"
                    item_value="grower_name"
                    data={
                      filteredGrowerDropDown?.length > 0 &&
                      filteredGrowerDropDown
                    }
                    callback={_growerCallback}
                    placeholder="Grower Name"
                    disabled={!allContractData}
                  />
                </div>
              </div>
              <div className="df mb10 jcsb">
                <div className="w100%">
                  <TypeAhead
                    className={'mb20'}
                    value={searchContractID}
                    onChange={handleSearchContractId}
                    item_id="contract_id"
                    item_value="contract_id"
                    data={
                      filteredContractIdDropDown?.length > 0 &&
                      filteredContractIdDropDown
                    }
                    callback={_contractIdCallback}
                    placeholder="Contract ID"
                    disabled={!allContractData}
                  />
                </div>
              </div>
              <div className="w150 select-btn">
                <Select
                  handleSelection={year => {
                    if (year !== reportYear) {
                      setReport([])
                      setReportYear(year)
                    }
                  }}
                  defaultValue={reportYear}
                  options={
                    yearsOptions.length > 0 ? yearsOptions : ['select', '2024']
                  }
                  disabled={!allContractData}
                />
              </div>
            </div>
            <div className="pdf-btn">
              <Button
                onClick={callToDownloadExlSheet}
                customClassName="mr10"
                backgroundColor={company ? '#238661' : '#8FC0AE'}
                textColor={'#FFFFFF'}
                disabled={report.length === 0}
                text="Download as Excel"
              />
              <Button
                onClick={e => setShowModal(true)}
                customClassName="mr10"
                backgroundColor={company ? '#238661' : '#8FC0AE'}
                textColor={'#FFFFFF'}
                disabled={report.length === 0}
                text="Download as PDF"
              />
            </div>
          </div>
          <div className="tabs" role="tablist">
            <button
              type="button"
              role="tab"
              id="tab-grain"
              aria-selected={deliveryType.index === 1}
              aria-controls="panel-grain"
              className={`tab-button ${deliveryType.index === 1 ? 'lineBar' : ''}`}
              onClick={() => handleTabSelection('grain', 1)}
            >
              Grain
            </button>
            {isContractCommFeed && (
              <button
                type="button"
                role="tab"
                id="tab-silage"
                aria-selected={deliveryType.index === 2}
                aria-controls="panel-silage"
                className={`tab-button ${deliveryType.index === 2 ? 'lineBar' : ''}`}
                onClick={() => handleTabSelection('silage', 2)}
              >
                Silage
              </button>
            )}
            {isContractCommFeed && (
              <button
                type="button"
                role="tab"
                id="tab-earlage"
                aria-selected={deliveryType.index === 3}
                aria-controls="panel-earlage"
                className={`tab-button ${deliveryType.index === 3 ? 'lineBar' : ''}`}
                onClick={() => handleTabSelection('earlage', 3)}
              >
                Earlage
              </button>
            )}
            {isContractCommFeed && (
              <button
                type="button"
                role="tab"
                id="tab-high-moisture"
                aria-selected={deliveryType.index === 4}
                aria-controls="panel-high-moisture"
                className={`tab-button ${deliveryType.index === 4 ? 'lineBar' : ''}`}
                onClick={() => handleTabSelection('high-moisture', 4)}
              >
                High moisture
              </button>
            )}
          </div>
          <TableContainer
            data={report}
            columns={columns}
            noData={report.length === 0 ? true : false}
            status={reportStatus}
          />
        </div>
      </div>
      <Modal autoHeight show={showModal} handleClose={handleClose}>
        <div
          className="modalContainer"
          style={{
            display: showModal ? 'block' : 'none',
            backgroundColor: 'rgba(0, 0, 0, 1%'
          }}
        >
          <div
            className="aHModalChild posr t100"
            style={{ maxWidth: '1200px' }}
          >
            <div className="modalStyle w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40">
              <div className="cancelDiv">
                <div>Net Bushels Report</div>
                <CloseButton closeAction={handleClose} src={close} />
              </div>
              {reportPdfUrl && (
                <object
                  data={reportPdfUrl}
                  type="application/pdf"
                  className="pdf-container"
                >
                  <p>This browser does not support PDFs.</p>
                </object>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
export default NetBushelsReport

const TableContainer = ({ data, columns, status }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data })

  return (
    <div className="table-report" id="table-to-pdf">
      <div
        className={
          status === 'LOADING' || status === 'EMPTY' ? 'loaderDiv' : ''
        }
      >
        <div className="table-container">
          <table
            {...getTableProps()}
            className="custom-table"
            id="table-to-pdf"
            border={status === 'EMPTY' || status === 'LOADING' ? '0' : '1'}
            cellSpacing="0"
            cellPadding="0"
            style={{
              overflow: 'hidden',
              borderRadius: `${
                status === 'EMPTY' || status === 'LOADING'
                  ? '8px 8px 0px 0px'
                  : '8px'
              }`
            }}
          >
            <thead className="custom-header">
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps()}
                      style={{ padding: '7px', minWidth: '80px' }}
                    >
                      {column.render('Header')}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            {status !== 'LOADING' && (
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row)
                  const { cells } = row
                  const previousRow = rows[i - 1]
                    ? rows[i - 1].original.company
                    : null
                  const currentRow = row.original.company
                  // const nextRow = rows[i + 1]
                  //   ? rows[i + 1].original.company
                  //   : null
                  const rowspan = rows.filter(
                    r => r.original.company === currentRow
                  ).length

                  return (
                    <tr {...row.getRowProps()}>
                      {i === 0 || currentRow !== previousRow ? (
                        <td
                          rowSpan={rowspan}
                          style={{
                            verticalAlign: 'middle',
                            fontSize: '15px',
                            minWidth: '100px'
                          }}
                        >
                          {row.values.company}
                        </td>
                      ) : null}
                      {cells.slice(1).map((cell, j) => (
                        <td
                          {...cell.getCellProps()}
                          className="custom-row"
                          style={{
                            minWidth: '80px',
                            padding: j === 0 ? '5px' : ''
                          }}
                        >
                          {typeof cell.value === 'number' && !isNaN(cell.value)
                            ? cell.value.toLocaleString()
                            : cell.value}
                        </td>
                      ))}
                    </tr>
                  )
                })}
              </tbody>
            )}
          </table>
          {status ? <TableStatus status={status} prompt="No Data" /> : null}
        </div>
      </div>
    </div>
  )
}
